﻿@keyframes fe-pulse-ring {
    0% {
        box-shadow: 0 0 0 0 rgba(112, 77, 255, 0.5);
    }
    70% {
        box-shadow: 0 0 0 8px rgba(112, 77, 255, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(112, 77, 255, 0);
    }
}

.fe-pulse-highlight {
    display: inline-flex;
    border-radius: var(--fe-pulse-border-radius, 4px);
    animation: fe-pulse-ring 2.2s ease-out infinite;
}

/* Fallback for users who prefer reduced motion: show a static glow instead */
@media (prefers-reduced-motion: reduce) {
    .fe-pulse-highlight {
        animation: none;
        box-shadow: 0 0 0 2px rgba(112, 77, 255, 0.35);
    }
}

